import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=c8aa5972&scoped=true&"
import script from "./AliPlayer.vue?vue&type=script&lang=js&"
export * from "./AliPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AliPlayer.vue?vue&type=style&index=0&id=c8aa5972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aa5972",
  null
  
)

export default component.exports